<template>
    <!--<div>
        <div :class="{'no-pointer-events': isLoading}" class="add-to-basket-lg-container d-none d-lg-block" v-if="!showQuantity && useLargeScale && canBeAddedToBasket"
             v-tooltip data-toggle="tooltip" data-placement="top" :title="$translate('Ceres::Template.singleItemAddToBasket')" @click="addToBasket()">
            <icon icon="cart-plus" class="fa-lg mobile-icon-right" :loading="isLoading"></icon>
        </div>

        <div class="add-to-basket-lg-container d-none d-lg-block" v-if="!showQuantity && useLargeScale && !canBeAddedToBasket"
             v-tooltip data-toggle="tooltip" data-placement="top" :title="$translate('Ceres::Template.itemShowItem')" @click="directToItem()">
            <i class="fa fa-arrow-right fa-lg d-none d-sm-block"></i>
        </div>

        <div class="d-inline" v-if="showQuantity && !useLargeScale" :class="{'d-lg-none': !$ceres.isItemView }">
            <div class="add-to-basket-container">
                <div class="quantity-input-container">
                    <quantity-input :value="quantity"
                                    @quantity-change="updateQuantity"
                                    @out-of-stock="handleButtonState"
                                    :timeout="0"
                                    :min="minimumQuantity"
                                    :max="maximumQuantity"
                                    :interval="intervalQuantity"
                                    :variation-id="variationId"
                                    :waiting="isLoading || !isSalable || !allVariationsSelected">
                    </quantity-input>
                </div>

                <button
                        v-if="!allVariationsSelected || !isSalable"
                        class="btn btn-block btn-primary btn-appearance disabled"
                        v-tooltip
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="tooltipText"
                        :class="buttonClasses"
                        :style="paddingInlineStyles">
                    <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                    {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                </button>
                <button
                        v-else-if="!buttonLockState"
                        :disabled="isLoading || !hasPrice"
                        class="btn btn-block btn-primary btn-appearance"
                        @click="addToBasket()"
                        :class="buttonClasses"
                        :style="paddingInlineStyles">
                    <icon icon="shopping-cart" :loading="isLoading"></icon>
                    {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                </button>
                <button v-else
                        class="btn btn-block btn-primary btn-appearance disabled"
                        v-tooltip
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="'Ceres::Template.singleItemQuantityMax' | translate({ max: maximumQuantity })"
                        :class="buttonClasses"
                        :style="paddingInlineStyles">
                    <icon icon="shopping-cart" :waiting="isLoading"></icon>
                    {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                </button>
            </div>
        </div>

        <div class="d-inline" v-if="!showQuantity && !useLargeScale" :class="{'d-lg-none': !isWishList }">
            <div class="btn-group" role="group" aria-label="Thumb Control">
                <button type="button" :class="{'no-pointer-events': isLoading}" v-if="canBeAddedToBasket" class="btn btn-primary btn-appearance mobile-width-button" @click="addToBasket()">
                    <icon icon="shopping-cart" class="fa-lg mobile-icon-right" :loading="isLoading"></icon>
                    {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                </button>
                <button type="button" v-if="!canBeAddedToBasket" class="btn btn-primary btn-appearance mobile-width-button" @click="directToItem()">
                    <i class="fa fa-arrow-right fa-lg d-none d-sm-block" aria-hidden="true"></i>
                    {{ $translate("Ceres::Template.itemShowItem") }}
                </button>
            </div>
        </div>
    </div>-->

    <div>
        <div class="category-item__add-to-basket" v-if="!showQuantity && useLargeScale && canBeAddedToBasket"
             v-tooltip data-toggle="tooltip" data-placement="top" title="In die Naschtüte">
            <button class="btn btn-primary btn-block article-card__btn">In die Naschtüte</button>
        </div>

        <div class="category-item__add-to-basket" v-if="!showQuantity && useLargeScale && !canBeAddedToBasket"
             v-tooltip data-toggle="tooltip" data-placement="top" :title="$translate('Ceres::Template.itemShowItem')">
            <button class="btn btn-primary btn-block article-card__btn article-card__btn--show" @click="goToItem($event.target)">{{ $translate("Ceres::Template.itemShowItem") }}</button>
        </div>

        <div class="category-list-view-port" v-if="showQuantity && !useLargeScale">
            <span>
                <div :class="{'col-12 col-md-12 col-lg-12 my-3' : !onlyQty}">
                    <div class="add-to-basket-container d-flex justify-content-between">
                        <div class="quantity-input-container">
                            <quantity-input
                                            :value="quantity"
                                            @quantity-change="updateQuantity"
                                            @out-of-stock="handleButtonState"
                                            :timeout="0"
                                            :min="minimumQuantity"
                                            :max="maximumQuantity"
                                            :interval="intervalQuantity"
                                            :variation-id="variationId"
                                            :waiting="isLoading || !isSalable || !allVariationsSelected">
                          </quantity-input>
                        </div>

                        <button v-if="!allVariationsSelected" class="btn btn-block btn-primary disabled article-card__btn" v-tooltip data-toggle="tooltip" data-placement="top" :title="$translate('Ceres::Template.singleItemPleaseSelectValidVariation')">
                            In die Naschtüte
                        </button>
                        <button v-else-if="!buttonLockState" :disabled="isLoading || !hasPrice" class="btn btn-block btn-primary article-card__btn" @click="addToBasket()">
                          <div class="d-none d-md-flex d-xl-none justify-content-center align-items-center">
                            <svg class="" width="18" height="25" viewBox="0 0 35 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <defs></defs>
                              <g id="header/header-xl" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1608.000000, -84.000000)">
                                  <g id="header-lg" fill="#FFFFFF">
                                      <g id="head" transform="translate(0.000000, 45.000000)">
                                          <g id="basket" transform="translate(1597.000000, 22.000000)">
                                              <g id="basket-full" transform="translate(0.250000, 0.296875)">
                                                  <path d="M43.3893,57.0679 C43.3643,57.0959 43.3233,57.1309 43.2533,57.1309 L12.6013,57.1309 C12.5323,57.1309 12.4903,57.0959 12.4663,57.0679 C12.4453,57.0439 12.4253,57.0089 12.4213,56.9569 L14.2623,51.1149 L14.4113,20.4349 L15.1233,21.1469 L17.2593,19.0109 L19.3923,21.1469 L21.5243,19.0109 L23.6603,21.1469 L25.7933,19.0109 L27.9293,21.1469 L30.0623,19.0109 L32.1943,21.1469 L34.3303,19.0109 L36.4633,21.1469 L38.5993,19.0109 L40.7323,21.1469 L41.4443,20.4349 L41.5313,51.1079 L43.4343,56.9609 C43.4313,57.0089 43.4103,57.0439 43.3893,57.0679 M44.8373,56.7139 C44.9073,57.1749 44.7743,57.6409 44.4693,57.9959 C44.1633,58.3499 43.7223,58.5509 43.2533,58.5509 L12.6013,58.5509 C12.1363,58.5509 11.6913,58.3499 11.3893,57.9959 C11.0843,57.6409 10.9483,57.1719 11.0183,56.7139 L11.0423,56.6029 L13.0153,50.3399 L12.9903,48.4129 L12.9903,16.9999 L15.1233,19.1319 L17.2593,16.9999 L19.3923,19.1319 L21.5283,16.9999 L23.6603,19.1319 L25.7933,16.9999 L27.9293,19.1319 L30.0623,16.9999 L32.1983,19.1319 L34.3303,16.9999 L36.4633,19.1319 L38.5993,16.9999 L40.7323,19.1319 L42.8683,16.9999 L42.8683,49.0339 L42.7773,50.3439 L44.8373,56.7139 Z M33.6193,27.9653 C33.2263,27.9653 32.9073,28.2803 32.9073,28.6773 L32.9073,32.9423 C32.9073,35.6893 30.6733,37.9233 27.9293,37.9233 C25.1813,37.9233 22.9493,35.6893 22.9493,32.9423 L22.9493,28.6773 C22.9493,28.2803 22.6293,27.9653 22.2373,27.9653 C21.8443,27.9653 21.5243,28.2803 21.5243,28.6773 L21.5243,32.9423 C21.5243,36.4743 24.3963,39.3473 27.9293,39.3473 C31.4583,39.3473 34.3303,36.4743 34.3303,32.9423 L34.3303,28.6773 C34.3303,28.2803 34.0113,27.9653 33.6193,27.9653 Z M35.7511,29.3853 C36.1471,29.3853 36.4631,29.0703 36.4631,28.6773 C36.4631,27.1073 35.1891,25.8283 33.6191,25.8283 C32.0491,25.8283 30.7731,27.1073 30.7731,28.6773 C30.7731,29.0703 31.0901,29.3853 31.4861,29.3853 C31.8781,29.3853 32.1941,29.0703 32.1941,28.6773 C32.1941,27.8923 32.8341,27.2533 33.6191,27.2533 C34.4031,27.2533 35.0431,27.8923 35.0431,28.6773 C35.0431,29.0703 35.3591,29.3853 35.7511,29.3853 Z M22.237,27.2534 C23.022,27.2534 23.66,27.8924 23.66,28.6774 C23.66,29.0694 23.977,29.3854 24.373,29.3854 C24.765,29.3854 25.081,29.0694 25.081,28.6774 C25.081,27.1074 23.806,25.8284 22.237,25.8284 C20.667,25.8284 19.392,27.1074 19.392,28.6774 C19.392,29.0694 19.712,29.3854 20.104,29.3854 C20.497,29.3854 20.816,29.0694 20.816,28.6774 C20.816,27.8924 21.452,27.2534 22.237,27.2534 Z" id="Fill-7"></path>
                                              </g>
                                          </g>
                                      </g>
                                  </g>
                              </g>
                          </svg>

                          +
                          </div>


                          <span class="d-md-none d-xl-block">
                            In die Naschtüte
                          </span>
                        </button>
                        <button v-else
                                class="btn btn-block btn-primary disabled article-card__btn"
                                v-tooltip
                                data-toggle="tooltip"
                                data-placement="top"
                                :title="'Ceres::Template.singleItemQuantityMax' | translate({max: item.variation.maximumOrderQuantity})"> <!-- :class="{'d-none' : onlyQty}" -->
                            <i v-waiting-animation="isLoading" class="fa fa-shopping-cart" aria-hidden="true"></i>
                            In die Naschtüte
                        </button>

                        <!--<add-to-wish-list :variation-id="variationId"></add-to-wish-list>-->
                    </div>
                </div>

            </span>
        </div>

        <div class="category-list-view-port" v-if="!showQuantity && !useLargeScale && !isWishList">
            <div class="btn-group" role="group" aria-label="Thumb Control">
                <button type="button" v-if="canBeAddedToBasket" class="btn btn-outline-primary mobile-width-button" @click="addToBasket()">
                    <i class="fa fa-cart-plus fa-lg mobile-icon-right" aria-hidden="true"></i>
                    <span class="mobile-text-only">In die Naschtüte</span>
                </button>
                <button type="button" v-if="!canBeAddedToBasket" class="btn btn-outline-primary mobile-width-button" @click="directToItem()">
                    <i class="fa fa-arrow-right fa-lg mobile-icon-right" aria-hidden="true"></i>
                    <span class="mobile-text-only">{{ $translate("Ceres::Template.itemShowItem") }}</span>
                </button>
            </div>
        </div>

        <div class="category-list-view-port" v-if="!showQuantity && !useLargeScale && isWishList">
            <div class="btn-group" role="group" aria-label="Thumb Control">
                <button type="button" v-if="canBeAddedToBasket" class="btn btn-primary mobile-width-button" @click="addToBasket()">
                    <i class="fa fa-cart-plus fa-lg mobile-icon-right" aria-hidden="true"></i>
                    <span class="mobile-text-only">In die Naschtüte</span>
                </button>
                <button type="button" v-if="!canBeAddedToBasket" class="btn btn-primary mobile-width-button" @click="directToItem()">
                    <i class="fa fa-arrow-right fa-lg mobile-icon-right" aria-hidden="true"></i>
                    <span class="mobile-text-only">{{ $translate("Ceres::Template.itemShowItem") }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ExceptionMap from "ceres/app/exceptions/ExceptionMap";
import { navigateTo } from "ceres/app/services/UrlService";
import { isNullOrUndefined, isDefined } from "ceres/app/helper/utils";
import { mapState } from "vuex";
import { ButtonSizePropertyMixin } from "ceres/app/mixins/buttonSizeProperty.mixin";
import QuantityInput from "../item/QuantityInput.vue";

const NotificationService = require("ceres/app/services/NotificationService");

export default {
	name: "add-to-basket",

	mixins: [ButtonSizePropertyMixin],

  components:
      {
        QuantityInput
      },

    props:
    {
        itemUrl: String,
        showQuantity:
        {
            type: Boolean,
            default: false
        },
        useLargeScale:
        {
            type: Boolean,
            default: false
        },
        variationId:
        {
            type: Number
        },
        isSalable:
        {
            type: Boolean,
            default: false
        },
        hasChildren:
        {
            type: Boolean,
            default: false
        },
        intervalQuantity:
        {
            type: Number,
            default: 1
        },
        minimumQuantity:
        {
            type: Number,
            default: 0
        },
        maximumQuantity:
        {
            type: Number,
            default: null
        },
        onlyQty:
        {
            type: Boolean,
            default:false
        },
        orderProperties:
        {
            type: Array,
            default: () => []
        },
				hasOrderProperties:
					{
						type: Boolean,
						default: false
					},
				hasRequiredOrderProperty:
					{
						type: Boolean,
						default: false
					},
				hasPrice:
					{
						type: Boolean,
						default: true
					},
				hasGraduatedPrice:
					{
						type: Boolean,
						default: false
					},
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        isWishList:
        {
            type: Boolean,
            default: false
        },
        propQuantity:
        {
            type: Number,
            default: null
        },
        itemType:
        {
            type: String,
            default: null
        }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {
        isSet()
        {
            return (
                this.$store.state.items[this.itemId]
                && this.$store.state.items[this.itemId].variation
                && this.$store.state.items[this.itemId].variation.documents[0].data.item.itemType === "set"
            ) || this.itemType === "set";
        },

        canBeAddedToBasket()
        {
            return this.isSalable &&
                !this.hasChildren &&
                !(this.minimumQuantity != 1 || this.intervalQuantity != 1) &&
                !this.requiresProperties &&
                this.hasPrice &&
								!this.hasGraduatedPrice &&
								!this.isSet;
        },

        requiresProperties()
        {
					return (App.config.item.requireOrderProperties &&
									(this.hasOrderProperties || this.orderProperties.filter(property => property.property.isShownOnItemPage).length > 0)) ||
									this.hasRequiredOrderProperty;
        },

        buttonClasses()
        {
            const classes = [];

            if (isDefined(this.buttonSizeClass))
            {
                classes.push(this.buttonSizeClass);
            }

            if (isDefined(this.paddingClasses))
            {
                classes.push(this.paddingClasses.split(" "));
            }

            return classes;
        },

        tooltipText()
        {
            if (this.hasAvailableVariations)
            {
                return this.$translate("Ceres::Template.singleItemPleaseSelectValidVariation");
            }
            else
            {
                return this.$translate("Ceres::Template.singleItemPleaseSelectNotAvailable");
            }
        },

        variationOrderQuantity()
        {
            return this.$store.state.items[this.itemId] && this.$store.state.items[this.itemId].variationOrderQuantity;
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        hasAvailableVariations()
        {
            return this.$store.state.items[this.itemId]
                && this.$store.state.items[this.itemId].variationSelect
                && this.$store.state.items[this.itemId].variationSelect.variations.some(variation => variation.isSalable);
        },

        allVariationsSelected()
        {
            if (this.isSet)
            {
                return this.$store.getters["itemSetAllVariationSelected"];
            }
            else
            {
                // FIX return true if module is not registered. This equals the default value from the module
                // and is required to use this component in other contexts, e.g. the category view
                return !this.$store.state.items[this.itemId]
                    || (this.$store.state.items[this.itemId].variationSelect
                        && this.$store.state.items[this.itemId].variationSelect.isVariationSelected);
            }
        },

        isLoading()
        {
            return this.$store.state.items.isAddToBasketLoading === this.variationId || this.$store.state.items.isSetLoading;
        },

        ...mapState({
            basketItems: state => state.basket.items,
            isBasketLoading: state => state.basket.isBasketLoading
        })
    },

    data()
    {
        return {
            quantity: 1,
            buttonLockState: false
        };
    },

    methods:
    {
        goToItem(event){
            window.location.href = $(event).closest(".thumb-content").find("a.thumb-title").attr("href");
        },
        /**
         * add an item to basket-resource
         */
        addToBasket()
        {
            this.$store.dispatch("loadComponent", "add-item-to-basket-overlay");
            this.$store.dispatch("loadComponent", "basket-preview");

            if (this.variationMissingProperties !== undefined && this.variationMissingProperties.length)
            {
                this.showMissingPropertiesError();
            }
            else if (this.isSalable || this.isSet)
            {
                this.$store.commit("setIsAddToBasketLoading", this.variationId);

                const orderParamsAndSurcharge = extractPropertiesAndSurcharge(this.orderProperties);

                const basketObject =
                    {
                        variationId             :   this.variationId,
                        quantity                :   this.quantity,
                        basketItemOrderParams   :   orderParamsAndSurcharge.orderParams,
                        totalOrderParamsMarkup  :   orderParamsAndSurcharge.totalSurcharge
                    };

                if(this.isSet)
                {
                    const setComponents = [];
                    this.$store.state.items.setComponentIds.forEach(itemId =>
                    {
                        const setComponent = this.$store.getters[`${itemId}/currentItemVariation`];

                        const variationId = setComponent && setComponent.variation.id;

                        // Extract order properties and total surcharge for set components
                        const setComponentOrderParamsAndSurcharge = extractPropertiesAndSurcharge(
                            setComponent.properties.filter(prop => prop.property.isOderProperty)
                        );

                        setComponents.push({
                            variationId: variationId,
                            quantity: this.$store.state.items[itemId].variationOrderQuantity,
                            basketItemOrderParams: setComponentOrderParamsAndSurcharge.orderParams,
                            totalOrderParamsMarkup: setComponentOrderParamsAndSurcharge.totalSurcharge
                        });
                    });
                    basketObject.setComponents = setComponents;
                }

                this.$store.dispatch("addBasketItem", basketObject).then(
                    response =>
                    {
                        document.dispatchEvent(new CustomEvent("afterBasketItemAdded", { detail: basketObject }));
                        this.$store.commit("setIsAddToBasketLoading", 0);

                        if(window.innerWidth >= 992){
                            setTimeout(function(){
                                document.body.classList.remove("basket-open");
                            }, 3000);
                        }

                    },
                    error =>
                    {
                        this.$store.commit("setIsAddToBasketLoading", 0);

                        if (error.data)
                        {
                            NotificationService.error(
                                this.$translate(
                                    "Ceres::Template." + ExceptionMap.get(error.data.exceptionCode.toString()),
                                    error.data.placeholder
                                )
                            ).closeAfter(5000);
                        }
                    });
            }
        },
        showMissingPropertiesError()
        {
            this.$store.commit(`${this.itemId}/setVariationMarkInvalidProps`, true);

            const propertyNames = this.variationMissingProperties.map(property => property.property.names.name);
            let errorMsgContent = "";

            for (const name of propertyNames)
            {
                errorMsgContent += name + "<br>";
            }

            NotificationService.error(this.$translate("Ceres::Template.singleItemMissingOrderPropertiesError").replace("<properties>", errorMsgContent));
        },

        directToItem()
        {
            navigateTo(this.itemUrl);
        },

        handleButtonState(value)
        {
            this.buttonLockState = value;
        },

        /**
         * update the property quantity of the current instance
         * @param value
         */
        updateQuantity(value)
        {
            this.quantity = value;
        }
    },

    watch:
    {
        quantity(value)
        {
            if(!isNullOrUndefined(this.itemId))
            {
                this.$store.commit(`${this.itemId}/setVariationOrderQuantity`, value);
                this.$store.commit(`${this.itemId}/setVariationPropertySurcharges`, this.$store.getters[`${this.itemId}/variationBasePrice`]);
            }
        },

        variationOrderQuantity(value)
        {
            if (this.quantity !== value)
            {
                this.quantity = value;
            }
        },

        propQuantity(value)
        {
            if (!isNaN(value))
            {
                this.quantity = value;
            }
        }
    }
}

function extractPropertiesAndSurcharge(orderProperties)
{
    let totalSurcharge = 0;
    const orderParams = [];

    orderProperties.forEach((orderProperty) =>
    {
        if(!isNullOrUndefined(orderProperty.property.value))
        {
            const property = orderProperty.property;

            if (property.valueType === "float" &&
                !isNullOrUndefined(property.value) &&
                property.value.slice(-1) === App.decimalSeparator)
            {
                property.value = property.value.substr(0, property.value.length - 1);
            }

            totalSurcharge += (orderProperty.surcharge || 0) + (property.surcharge || 0);

            orderParams.push({
                propertyId: property.id,
                type: property.valueType,
                name: property.names.name,
                value: property.value
            });
        }
    });

    return {
        orderParams: orderParams,
        totalSurcharge: totalSurcharge
    };
}
</script>
